import { AppShell, Box, Group, Text } from "@mantine/core";
import { useReducedMotion } from "@mantine/hooks";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useSnapshot } from "valtio";
import { AssistantFab } from "@/components/assistant/assistant-fab";
import {
	assistantAsideConfig,
	assistantHeaderStyle,
	useAssistantLayout,
	useAssistantSpace,
} from "@/components/assistant/use-assistant-space";
import { useIsDark } from "@/hooks/useIsDark";
import { i18nStore } from "@/store/i18n";

export const Route = createFileRoute("/profile")({
	component: ProfileLayout,
});

function ProfileLayout() {
	const dark = useIsDark();
	const assistantSpace = useAssistantSpace();
	const assistantLayout = useAssistantLayout(true);
	const reducedMotion = useReducedMotion();
	const { animasiTransisi } = useSnapshot(i18nStore);

	return (
		<AppShell
			header={{ height: 60 }}
			aside={assistantAsideConfig(assistantSpace)}
			transitionDuration={animasiTransisi && !reducedMotion ? 200 : 0}
			padding="md"
			styles={{
				main: {
					backgroundColor: dark
						? "var(--mantine-color-dark-8)"
						: "var(--mantine-color-gray-0)",
				},
			}}
		>
			<AppShell.Header
				style={{
					...assistantHeaderStyle(assistantLayout.headerInsetEnd),
					borderBottom: "1px solid var(--mantine-color-default-border)",
					backgroundColor: dark ? "var(--mantine-color-dark-7)" : "white",
					paddingLeft: "1rem",
					paddingRight: "1rem",
				}}
			>
				<Group h="100%" justify="space-between" wrap="nowrap">
					<Box style={{ flex: 1 }} />

					{/* Tengah: selalu center */}
					<Text
						fw={700}
						fz={{ base: "sm", sm: "lg" }}
						c="orange.6"
						style={{ whiteSpace: "nowrap" }}
					>
						PENGATURAN AKUN
					</Text>

					{/* Kanan: spacer mirror kiri */}
					<Box style={{ flex: 1 }} />
				</Group>
			</AppShell.Header>

			<AppShell.Main>
				<Outlet />
				<AssistantFab />
			</AppShell.Main>
		</AppShell>
	);
}
